$(function () {
  $('body').append('<button onclick="topFunction()" id="TopButton" title="Go to top"><i class="fa fa-angle-up" aria-hidden="true"></i></button>');
  $('.top-bar-shop-links ul.submenu').css('left', $('.top-bar-shop-links ul.nav').offset().left - $('.top-bar-shop-links ul#cart').offset().left - $('.top-bar-shop-links ul.submenu').width() + $('.top-bar-shop-links ul.nav').width());
  
/*  $('.mobile-nav-block ul.nav > li').click(function () {
    _this = $(this);
    if (_this.attr('aria-expanded'))
    { // expand
      _this.find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
    else
    {
      _this.find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      _this.attr('aria-expanded', false);
      
    }
  });
  */
  setTimeout(function () {
    console.log($('.video-div div div').css("padding-bottom", "56.25%"));
  }, 100);
});

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  var mybutton = document.getElementById("TopButton");
  if (mybutton)
  {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }
}

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}